mutation CreatePoll($input: CreatePollInput!) {
  createPoll(input: $input) {
    id
    question
  }
}
